
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireee5d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireee5d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = new Map();
function $ef7689007096c8a0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ef7689007096c8a0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $d930f65a59d20052$exports = {};

(parcelRequire("kyEFX")).register(new URL("", import.meta.url).toString(), JSON.parse('["3EsVB","index.681c27e2.js","cPzGy","icons.c14567a0.svg"]'));

const $ef19e442e0cefa4b$export$923ea8233b386e99 = "https://forkify-api.herokuapp.com/api/v2/recipes/";
const $ef19e442e0cefa4b$export$196440f71ed9f601 = 2;
const $ef19e442e0cefa4b$export$5feaddb1377b7f5e = 10;
const $ef19e442e0cefa4b$export$7167c830cefcb6b5 = "6f171b1b-7a45-4d91-a428-b1185abfda29"; // export const KEY = 'baaa8526-5076-41d6-a1bd-4c440b649037';



const $305e87f8b1fd70ca$var$timeout = function(s) {
    return new Promise(function(_, reject) {
        setTimeout(function() {
            reject(new Error(`Request took too long! Timeout after ${s} second`));
        }, s * 1000);
    });
};
const $305e87f8b1fd70ca$export$e68fce4c5f453854 = async (url, recipe)=>{
    try {
        const fetchPro = recipe ? fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(recipe)
        }) : fetch(url);
        const response = await Promise.race([
            fetchPro,
            $305e87f8b1fd70ca$var$timeout((0, $ef19e442e0cefa4b$export$196440f71ed9f601))
        ]);
        const data = await response.json();
        if (!response.ok) throw Error(`${data.message} (${response.status})`);
        return data;
    } catch (err) {
        throw new Error(err);
    }
};


const $0f43de04ce3b058c$export$ca000e230c0caa3e = {
    recipe: {},
    search: {
        query: "",
        results: [],
        page: 1,
        resultsPerPage: (0, $ef19e442e0cefa4b$export$5feaddb1377b7f5e)
    },
    bookmarks: [],
    isSearchOpen: false,
    isSearchWindowOpen: false
};
const $0f43de04ce3b058c$var$getRecipeObject = (data)=>{
    const { recipe: recipe } = data.data;
    return {
        cookingTime: recipe.cooking_time,
        id: recipe.id,
        imageUrl: recipe.image_url,
        ingredients: recipe.ingredients,
        publisher: recipe.publisher,
        servings: recipe.servings,
        sourceUrl: recipe.source_url,
        title: recipe.title,
        ...recipe.key && {
            key: recipe.key
        }
    };
};
const $0f43de04ce3b058c$export$b96725c7a035d60b = async (id)=>{
    try {
        const data = await (0, $305e87f8b1fd70ca$export$e68fce4c5f453854)(`${(0, $ef19e442e0cefa4b$export$923ea8233b386e99)}${id}?key=${(0, $ef19e442e0cefa4b$export$7167c830cefcb6b5)}`);
        $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe = $0f43de04ce3b058c$var$getRecipeObject(data);
        $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.bookmarked = $0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks.some((recipe)=>recipe.id === $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.id) ? true : false;
    } catch (err) {
        throw new Error(err);
    }
};
const $0f43de04ce3b058c$export$202b8e5cb363a0c4 = async (query)=>{
    try {
        $0f43de04ce3b058c$export$ca000e230c0caa3e.search.query = query;
        const data = await (0, $305e87f8b1fd70ca$export$e68fce4c5f453854)(`${(0, $ef19e442e0cefa4b$export$923ea8233b386e99)}?search=${query}&key=${(0, $ef19e442e0cefa4b$export$7167c830cefcb6b5)}`);
        $0f43de04ce3b058c$export$ca000e230c0caa3e.search.results = data.data.recipes.map((recipe)=>{
            return {
                id: recipe.id,
                imageUrl: recipe.image_url,
                publisher: recipe.publisher,
                title: recipe.title,
                ...recipe.key && {
                    key: recipe.key
                }
            };
        });
    } catch (err) {
        throw err;
    }
};
const $0f43de04ce3b058c$export$c6b70b628aa585b0 = (page = $0f43de04ce3b058c$export$ca000e230c0caa3e.search.page)=>{
    $0f43de04ce3b058c$export$ca000e230c0caa3e.search.page = page;
    const start = (page - 1) * (0, $ef19e442e0cefa4b$export$5feaddb1377b7f5e);
    const end = page * (0, $ef19e442e0cefa4b$export$5feaddb1377b7f5e);
    return $0f43de04ce3b058c$export$ca000e230c0caa3e.search.results.slice(start, end);
};
const $0f43de04ce3b058c$export$5e23f4642ecad5ea = (serving)=>{
    $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.ingredients.forEach((ing)=>{
        ing.quantity = ing.quantity * serving / $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.servings;
    });
    $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.servings = serving;
};
const $0f43de04ce3b058c$export$72009cc673d27d80 = (recipe)=>{
    $0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks.push(recipe);
    if (recipe.id === $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.id) $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.bookmarked = true;
    $0f43de04ce3b058c$export$c54ab59e0c864b2f();
};
const $0f43de04ce3b058c$export$2db69b245b3902c8 = (id)=>{
    const index = $0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks.findIndex((bookmark)=>bookmark.id === id);
    $0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks.splice(index, 1);
    if (id === $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.id) $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.bookmarked = false;
    $0f43de04ce3b058c$export$c54ab59e0c864b2f();
};
const $0f43de04ce3b058c$export$c54ab59e0c864b2f = ()=>{
    localStorage.setItem("bookmarks", JSON.stringify($0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks));
};
const $0f43de04ce3b058c$export$7c7816efe5f3d2b8 = ()=>{
    $0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks = JSON.parse(localStorage.getItem("bookmarks") ?? "[]");
};
const $0f43de04ce3b058c$export$d660c2254e74960d = async (newRecipe)=>{
    try {
        const ingredients = Object.entries(newRecipe).filter((entry)=>entry[0].startsWith("ingredient") && entry[1].trim().length > 0).map((entry)=>{
            const ingArr = entry[1].split(",").map((ing)=>ing.trim());
            if (ingArr.length !== 3) throw new Error("Wrong Format Input");
            const [quantity, unit, description] = ingArr;
            return {
                quantity: quantity ? +quantity : null,
                unit: unit,
                description: description
            };
        });
        const recipe = {
            cooking_time: +newRecipe.cookingTime,
            image_url: newRecipe.image,
            ingredients: ingredients,
            publisher: newRecipe.publisher,
            servings: +newRecipe.servings,
            source_url: newRecipe.sourceUrl,
            title: newRecipe.title
        };
        const data = await (0, $305e87f8b1fd70ca$export$e68fce4c5f453854)(`${(0, $ef19e442e0cefa4b$export$923ea8233b386e99)}?key=${(0, $ef19e442e0cefa4b$export$7167c830cefcb6b5)}`, recipe);
        $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe = $0f43de04ce3b058c$var$getRecipeObject(data);
        $0f43de04ce3b058c$export$72009cc673d27d80($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe);
    } catch (err) {
        throw err;
    }
};


function $634c7e84fcedcea8$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


var $c4875025b8f68daf$exports = {};
$c4875025b8f68daf$exports = new URL("icons.c14567a0.svg", import.meta.url).toString();




class $4c29d8503f9ec531$export$2e2bcd8739ae039 {
    render(data, render = true) {
        if (!data || Array.isArray(data) && data.length === 0) return this.renderError();
        this._data = data;
        const markup = this._generateMarkup();
        if (!render) return markup;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    _clear() {
        this._parentElement.innerHTML = "";
    }
    update(data) {
        this._data = data;
        const newMarkup = this._generateMarkup();
        const newDom = document.createRange().createContextualFragment(newMarkup);
        const newDomElements = Array.from(newDom.querySelectorAll("*"));
        const curDomElements = Array.from(this._parentElement.querySelectorAll("*"));
        newDomElements.forEach((newDomEl, i)=>{
            if (!newDomEl.isEqualNode(curDomElements[i]) && newDomEl?.firstChild?.nodeValue.trim() !== "") curDomElements[i].textContent = newDomEl.textContent;
            if (!newDomEl.isEqualNode(curDomElements[i])) Array.from(newDomEl.attributes).forEach((attr)=>{
                curDomElements[i].setAttribute(attr.name, attr.value);
            });
        });
    }
    renderSpinner() {
        this._clear();
        const markup = `
      <div class="spinner">
        <svg>
          <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports)))}#icon-loader"></use>
        </svg>
      </div>
    `;
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    renderError(message = this._errorMessage) {
        const markup = `
      <div class="error">
      <div>
      <svg>
      <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports)))}#icon-alert-triangle"></use>
      </svg>
      </div>
      <p>${message}</p>
      </div>
      `;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    renderMessage(message = this._message) {
        const markup = `
        <div class="message">
        <div>
        <svg>
        <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports)))}#icon-smile"></use>
        </svg>
        </div>
        <p>${message}</p>
        </div>
        `;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    constructor(){
        (0, $634c7e84fcedcea8$export$1e71eb4bef00f6b0)(this, "_data", void 0);
    }
}


class $96ae62c5a8e43877$var$RecipeView extends (0, $4c29d8503f9ec531$export$2e2bcd8739ae039) {
    addHandlerRender(handler) {
        [
            "hashchange",
            "load"
        ].forEach((ev)=>{
            window.addEventListener(ev, handler);
        });
    }
    addHandlerUpdateServings(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const button = e.target.closest(".btn--tiny");
            const serving = +button?.dataset.serving;
            if (!button || serving <= 0 || serving > 100) return;
            handler(serving);
        });
    }
    addHandlerBookmark(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const button = e.target.closest(".btn--bookmark");
            if (!button) return;
            handler();
        });
    }
    _generateMarkup() {
        return `
        <figure class="recipe__fig">
        <img src="${this._data.imageUrl}" class="recipe__img" crossorigin/>
        <h1 class="recipe__title">
        <span>${this._data.title}</span>
        </h1>
        </figure>
        
        <div class="recipe__details">
        <div class="recipe__info-group">

        <div class="recipe__info">
        <svg class="recipe__info-icon">
        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports))}#icon-clock"></use>
        </svg>
        <span class="recipe__info-data recipe__info-data--minutes">${this._data.cookingTime}</span>
        <span class="recipe__info-text">minutes</span>
        </div>
        <div class="recipe__info">
        <svg class="recipe__info-icon">
        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports))}#icon-users"></use>
        </svg>
        <span class="recipe__info-data recipe__info-data--people">${this._data.servings}</span>
        <span class="recipe__info-text">servings</span>
        
        <div class="recipe__info-buttons">
        <button data-serving=${this._data.servings - 1} class="btn--tiny btn--increase-servings">
        <svg>
        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports))}#icon-minus-circle"></use>
        </svg>
        </button>
        <button data-serving=${this._data.servings + 1} class="btn--tiny btn--increase-servings">
        <svg>
        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports))}#icon-plus-circle"></use>
        </svg>
        </button>
        </div>
        </div>
        </div>

        <div class="recipe__user-generated ${this._data.key ? "" : "hidden"}">
            <svg>
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports))}#icon-user"></use>
            </svg>
        </div>
        <button class="btn--round btn--bookmark">
        <svg class="">
        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports))}#icon-bookmark${this._data.bookmarked ? "-fill" : ""}"></use>
        </svg>
        </button>
        </div>
        
        <div class="recipe__ingredients">
        <h2 class="heading--2">Recipe ingredients</h2>
        <ul class="recipe__ingredient-list">
        ${this._data.ingredients.map(this._generateIngredients).join("\n")}
        </ul>
        </div>
        
        <div class="recipe__directions">
        <h2 class="heading--2">How to cook it</h2>
        <p class="recipe__directions-text">
        This recipe was carefully designed and tested by
        <span class="recipe__publisher">${this._data.publisher}</span>. Please check out
        directions at their website.
        </p>
        <a
        class="btn--small recipe__btn"
        href="${this._data.sourceUrl}"
        target="_blank"
        >
        <span>Directions</span>
        <svg class="search__icon">
        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports))}#icon-arrow-right"></use>
        </svg>
        </a>
        </div>
        `;
    }
    _generateIngredients(ing) {
        return `
        <li class="recipe__ingredient">
        <svg class="recipe__icon">
        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports))}#icon-check"></use>
        </svg>
        <div class="recipe__quantity">${ing.quantity ?? ""}</div>
        <div class="recipe__description">
        <span class="recipe__unit">${ing.unit ?? ""}</span>
        ${ing.description}
        </div>
        </li>
        `;
    }
    constructor(...args){
        super(...args);
        (0, $634c7e84fcedcea8$export$1e71eb4bef00f6b0)(this, "_parentElement", document.querySelector(".recipe"));
        (0, $634c7e84fcedcea8$export$1e71eb4bef00f6b0)(this, "_errorMessage", "No recipes found for your query. Please try again!");
        (0, $634c7e84fcedcea8$export$1e71eb4bef00f6b0)(this, "_message", "");
    }
}
var $96ae62c5a8e43877$export$2e2bcd8739ae039 = new $96ae62c5a8e43877$var$RecipeView();


function $23064e67de588bbb$export$184ff5d81c0e5775(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}


function $82dfaf3e78086f9a$export$20c20a422940e173(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}


function $1ad550d5c291b3dc$export$5a67b255b80ee4f2(receiver, privateMap) {
    var descriptor = (0, $82dfaf3e78086f9a$export$20c20a422940e173)(receiver, privateMap, "get");
    return (0, $23064e67de588bbb$export$184ff5d81c0e5775)(receiver, descriptor);
}


function $62f90c0da26e8f0e$export$6b10452b5ac97eba(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $b077a3c21f489735$export$e235798705076415(obj, privateMap, value) {
    (0, $62f90c0da26e8f0e$export$6b10452b5ac97eba)(obj, privateMap);
    privateMap.set(obj, value);
}


function $a9b3ccfdb74c7183$export$ccedaf978f62b9dd(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}



function $519a80ad1140b712$export$1002c20f28174dbf(obj, privateSet) {
    (0, $62f90c0da26e8f0e$export$6b10452b5ac97eba)(obj, privateSet);
    privateSet.add(obj);
}



var $59c24ae67929f662$var$_parentElement = /*#__PURE__*/ new WeakMap(), $59c24ae67929f662$var$_searchButton = /*#__PURE__*/ new WeakMap(), $59c24ae67929f662$var$_searchWindow = /*#__PURE__*/ new WeakMap(), $59c24ae67929f662$var$_searchWindowButton = /*#__PURE__*/ new WeakMap(), $59c24ae67929f662$var$_clear = /*#__PURE__*/ new WeakSet();
class $59c24ae67929f662$var$SearchView {
    _addHandlerWindow() {
        (0, $1ad550d5c291b3dc$export$5a67b255b80ee4f2)(this, $59c24ae67929f662$var$_searchWindowButton).addEventListener("click", (e)=>{
            this.toggleWindow();
        });
    }
    getQuery() {
        const query = (0, $1ad550d5c291b3dc$export$5a67b255b80ee4f2)(this, $59c24ae67929f662$var$_parentElement).querySelector(".search__field").value;
        (0, $a9b3ccfdb74c7183$export$ccedaf978f62b9dd)(this, $59c24ae67929f662$var$_clear, $59c24ae67929f662$var$clear).call(this);
        return query;
    }
    addSearchHandler(handler) {
        (0, $1ad550d5c291b3dc$export$5a67b255b80ee4f2)(this, $59c24ae67929f662$var$_parentElement).addEventListener("submit", (e)=>{
            e.preventDefault();
            handler((0, $1ad550d5c291b3dc$export$5a67b255b80ee4f2)(this, $59c24ae67929f662$var$_parentElement));
            this.toggleWindow(true);
        });
    }
    addSearchButtonHandler(handler) {
        (0, $1ad550d5c291b3dc$export$5a67b255b80ee4f2)(this, $59c24ae67929f662$var$_searchButton).addEventListener("click", (e)=>{
            e.preventDefault();
            handler((0, $1ad550d5c291b3dc$export$5a67b255b80ee4f2)(this, $59c24ae67929f662$var$_parentElement), (0, $1ad550d5c291b3dc$export$5a67b255b80ee4f2)(this, $59c24ae67929f662$var$_searchButton));
        });
    }
    addSearchWindowHandler(handler) {
        (0, $1ad550d5c291b3dc$export$5a67b255b80ee4f2)(this, $59c24ae67929f662$var$_searchWindowButton).addEventListener("click", (e)=>{
            e.preventDefault();
            handler((0, $1ad550d5c291b3dc$export$5a67b255b80ee4f2)(this, $59c24ae67929f662$var$_searchWindow), (0, $1ad550d5c291b3dc$export$5a67b255b80ee4f2)(this, $59c24ae67929f662$var$_searchWindowButton));
        });
    }
    toggleWindow(toOpen = null) {
        if ((0, $1ad550d5c291b3dc$export$5a67b255b80ee4f2)(this, $59c24ae67929f662$var$_searchWindowButton).classList.contains("search-window__btn-hide") && (0, $0f43de04ce3b058c$export$ca000e230c0caa3e).search.query) (0, $1ad550d5c291b3dc$export$5a67b255b80ee4f2)(this, $59c24ae67929f662$var$_searchWindowButton).classList.remove("search-window__btn-hide");
        if (toOpen == null) {
            if ((0, $0f43de04ce3b058c$export$ca000e230c0caa3e).search.query) (0, $1ad550d5c291b3dc$export$5a67b255b80ee4f2)(this, $59c24ae67929f662$var$_searchWindow).classList.toggle("search-results-open");
            document.body.classList.toggle("body--no-scroll");
        } else if (toOpen) {
            (0, $1ad550d5c291b3dc$export$5a67b255b80ee4f2)(this, $59c24ae67929f662$var$_searchWindow).classList.add("search-results-open");
            document.body.classList.add("body--no-scroll");
        } else {
            (0, $1ad550d5c291b3dc$export$5a67b255b80ee4f2)(this, $59c24ae67929f662$var$_searchWindow).classList.remove("search-results-open");
            document.body.classList.remove("body--no-scroll");
        }
    }
    constructor(){
        (0, $519a80ad1140b712$export$1002c20f28174dbf)(this, $59c24ae67929f662$var$_clear);
        (0, $b077a3c21f489735$export$e235798705076415)(this, $59c24ae67929f662$var$_parentElement, {
            writable: true,
            value: document.querySelector(".search")
        });
        (0, $b077a3c21f489735$export$e235798705076415)(this, $59c24ae67929f662$var$_searchButton, {
            writable: true,
            value: document.querySelector(".nav .search__btn")
        });
        (0, $b077a3c21f489735$export$e235798705076415)(this, $59c24ae67929f662$var$_searchWindow, {
            writable: true,
            value: document.querySelector(".search-results")
        });
        (0, $b077a3c21f489735$export$e235798705076415)(this, $59c24ae67929f662$var$_searchWindowButton, {
            writable: true,
            value: document.querySelector(".search-results .search-window__btn")
        });
        // super();
        this._addHandlerWindow();
    }
}
function $59c24ae67929f662$var$clear() {
    (0, $1ad550d5c291b3dc$export$5a67b255b80ee4f2)(this, $59c24ae67929f662$var$_parentElement).querySelector(".search__field").value = "";
    (0, $1ad550d5c291b3dc$export$5a67b255b80ee4f2)(this, $59c24ae67929f662$var$_parentElement).querySelector(".search__field").blur();
}
var $59c24ae67929f662$export$2e2bcd8739ae039 = new $59c24ae67929f662$var$SearchView();







class $8b7f4ee14226945a$var$resultView extends (0, $4c29d8503f9ec531$export$2e2bcd8739ae039) {
    _generateMarkup() {
        const id = window.location.hash.slice(1);
        return `
      <li class="preview">
        <a class="preview__link ${id === this._data.id ? "preview__link--active" : ""}" href="#${this._data.id}">
            <figure class="preview__fig">
            <img src="${this._data.imageUrl}" alt="${this._data.title}" crossorigin/>
            </figure>
            <div class="preview__this._data">
            <h4 class="preview__title">${this._data.title}</h4>
            <p class="preview__publisher">${this._data.publisher}</p>
            <div class="preview__user-generated ${this._data.key ? "" : "hidden"}">
                <svg>
                <use href="${0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports))}#icon-user"></use>
                </svg>
            </div>
            </div>
        </a>
      </li>
      `;
    }
    constructor(...args){
        super(...args);
        (0, $634c7e84fcedcea8$export$1e71eb4bef00f6b0)(this, "_parentElement", "");
    }
}
var $8b7f4ee14226945a$export$2e2bcd8739ae039 = new $8b7f4ee14226945a$var$resultView();



class $8c44018a83321aba$var$resultView extends (0, $4c29d8503f9ec531$export$2e2bcd8739ae039) {
    _generateMarkup() {
        return this._data.map((recipe)=>(0, $8b7f4ee14226945a$export$2e2bcd8739ae039).render(recipe, false)).join("\n");
    }
    constructor(...args){
        super(...args);
        (0, $634c7e84fcedcea8$export$1e71eb4bef00f6b0)(this, "_parentElement", document.querySelector(".results"));
        (0, $634c7e84fcedcea8$export$1e71eb4bef00f6b0)(this, "_errorMessage", "No recipes found for your query. Please try again!");
        (0, $634c7e84fcedcea8$export$1e71eb4bef00f6b0)(this, "_message", "");
    }
}
var $8c44018a83321aba$export$2e2bcd8739ae039 = new $8c44018a83321aba$var$resultView();






class $d5cb92833965f6d1$var$paginationView extends (0, $4c29d8503f9ec531$export$2e2bcd8739ae039) {
    addPaginationHandler(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const button = e.target.closest(".btn--inline");
            if (!button) return;
            const goto = +button.dataset.goto;
            handler(goto);
        });
    }
    _generateMarkup() {
        const curPage = this._data.page;
        const numPages = Math.ceil(this._data.results.length / (0, $ef19e442e0cefa4b$export$5feaddb1377b7f5e));
        let prevButton = `
      <button data-goto=${curPage - 1} class="btn--inline pagination__btn--prev">
        <svg class="search__icon">
          <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports)))}#icon-arrow-left"></use>
        </svg>
        <span>Page ${curPage - 1}</span>
      </button>
      `;
        let nextButton = `
        <button data-goto=${curPage + 1} class="btn--inline pagination__btn--next">
          <span>Page ${curPage + 1}</span>
          <svg class="search__icon">
            <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports)))}#icon-arrow-right"></use>
          </svg>
        </button>
      `;
        if (curPage === 1) prevButton = "";
        if (curPage === numPages) nextButton = "";
        return `${prevButton}${nextButton}`;
    }
    constructor(...args){
        super(...args);
        (0, $634c7e84fcedcea8$export$1e71eb4bef00f6b0)(this, "_parentElement", document.querySelector(".pagination"));
    }
}
var $d5cb92833965f6d1$export$2e2bcd8739ae039 = new $d5cb92833965f6d1$var$paginationView();






class $bb8c26dfe22e3ec0$var$BookmarksView extends (0, $4c29d8503f9ec531$export$2e2bcd8739ae039) {
    addHandlerRender(handler) {
        window.addEventListener("load", handler);
    }
    _generateMarkup() {
        return this._data.map((bookmark)=>(0, $8b7f4ee14226945a$export$2e2bcd8739ae039).render(bookmark, false)).join("\n");
    }
    constructor(...args){
        super(...args);
        (0, $634c7e84fcedcea8$export$1e71eb4bef00f6b0)(this, "_parentElement", document.querySelector(".bookmarks__list"));
        (0, $634c7e84fcedcea8$export$1e71eb4bef00f6b0)(this, "_errorMessage", "No bookmarks yet. Find a nice recipe and bookmark it :)");
        (0, $634c7e84fcedcea8$export$1e71eb4bef00f6b0)(this, "_message", "");
    }
}
var $bb8c26dfe22e3ec0$export$2e2bcd8739ae039 = new $bb8c26dfe22e3ec0$var$BookmarksView();






class $69f230dbd0cf4929$var$addRecipeView extends (0, $4c29d8503f9ec531$export$2e2bcd8739ae039) {
    toggleWindow() {
        this._overlay.classList.toggle("hidden");
        this._window.classList.toggle("hidden");
        this._clear();
        const markup = this._generateMarkup();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    _addHandlerOpen() {
        this._openBtn.addEventListener("click", this.toggleWindow.bind(this));
    }
    _addHandlerClose() {
        this._closeBtn.addEventListener("click", this.toggleWindow.bind(this));
        this._overlay.addEventListener("click", this.toggleWindow.bind(this));
    }
    addHandlerSubmit(handler) {
        this._parentElement.addEventListener("submit", function(e) {
            e.preventDefault();
            const dataArr = [
                ...new FormData(this)
            ];
            const data = Object.fromEntries(dataArr);
            handler(data);
        });
    }
    _generateMarkup() {
        return `
      <div class="upload__column">
      <h3 class="upload__heading">Recipe data</h3>
      <label>Title</label>
      <input required name="title" type="text" />
      <label>URL</label>
      <input required name="sourceUrl" type="text" />
      <label>Image URL</label>
      <input required name="image" type="text" />
      <label>Publisher</label>
      <input required name="publisher" type="text" />
      <label>Prep time</label>
      <input required name="cookingTime" type="number" />
      <label>Servings</label>
      <input required name="servings" type="number" />
    </div>

    <div class="upload__column">
      <h3 class="upload__heading">Ingredients</h3>
      <label>Ingredient 1</label>
      <input
        type="text"
        required
        name="ingredient-1"
        placeholder="Format: 'Quantity,Unit,Description'"
      />
      <label>Ingredient 2</label>
      <input
        type="text"
        name="ingredient-2"
        placeholder="Format: 'Quantity,Unit,Description'"
      />
      <label>Ingredient 3</label>
      <input
        type="text"
        name="ingredient-3"
        placeholder="Format: 'Quantity,Unit,Description'"
      />
      <label>Ingredient 4</label>
      <input
        type="text"
        name="ingredient-4"
        placeholder="Format: 'Quantity,Unit,Description'"
      />
      <label>Ingredient 5</label>
      <input
        type="text"
        name="ingredient-5"
        placeholder="Format: 'Quantity,Unit,Description'"
      />
      <label>Ingredient 6</label>
      <input
        type="text"
        name="ingredient-6"
        placeholder="Format: 'Quantity,Unit,Description'"
      />
    </div>

    <button class="btn upload__btn">
      <svg>
        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports))}#icon-upload-cloud"></use>
        
      </svg>
      <span>Upload</span>
    </button>
      `;
    }
    constructor(){
        super();
        (0, $634c7e84fcedcea8$export$1e71eb4bef00f6b0)(this, "_parentElement", document.querySelector(".upload"));
        (0, $634c7e84fcedcea8$export$1e71eb4bef00f6b0)(this, "_message", "Recipe Uploaded Successfully!");
        (0, $634c7e84fcedcea8$export$1e71eb4bef00f6b0)(this, "_overlay", document.querySelector(".overlay"));
        (0, $634c7e84fcedcea8$export$1e71eb4bef00f6b0)(this, "_window", document.querySelector(".add-recipe-window"));
        (0, $634c7e84fcedcea8$export$1e71eb4bef00f6b0)(this, "_closeBtn", document.querySelector(".btn--close-modal"));
        (0, $634c7e84fcedcea8$export$1e71eb4bef00f6b0)(this, "_openBtn", document.querySelector(".nav__btn--add-recipe"));
        this._addHandlerOpen();
        this._addHandlerClose();
    }
}
var $69f230dbd0cf4929$export$2e2bcd8739ae039 = new $69f230dbd0cf4929$var$addRecipeView();


// import 'core-js/stable';
// import { async } from 'regenerator-runtime/runtime';
// https://forkify-api.herokuapp.com/v2
///////////////////////////////////////
// if (module.hot) {
//   module.hot.accept();
// }
const $292b382f80842f30$var$getRecipe = async ()=>{
    try {
        const id = window.location.hash.slice(1);
        if (!id) return;
        (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).renderSpinner();
        (0, $8c44018a83321aba$export$2e2bcd8739ae039).update($0f43de04ce3b058c$export$c6b70b628aa585b0());
        (0, $bb8c26dfe22e3ec0$export$2e2bcd8739ae039).update($0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks);
        (0, $59c24ae67929f662$export$2e2bcd8739ae039).toggleWindow(false);
        await $0f43de04ce3b058c$export$b96725c7a035d60b(id);
        (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe);
    } catch (err) {
        (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).renderError(err);
    }
};
const $292b382f80842f30$var$controlSearchResults = async (parent)=>{
    try {
        (0, $8c44018a83321aba$export$2e2bcd8739ae039).renderSpinner();
        const query = (0, $59c24ae67929f662$export$2e2bcd8739ae039).getQuery();
        if (!query) return;
        await $0f43de04ce3b058c$export$202b8e5cb363a0c4(query);
        parent.classList.remove("search-open");
        $0f43de04ce3b058c$export$ca000e230c0caa3e.isSearchOpen = false;
        (0, $8c44018a83321aba$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$c6b70b628aa585b0(1));
        (0, $d5cb92833965f6d1$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.search);
    } catch (err) {}
};
const $292b382f80842f30$var$controlPagination = (goto)=>{
    (0, $8c44018a83321aba$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$c6b70b628aa585b0(goto));
    (0, $d5cb92833965f6d1$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.search);
};
const $292b382f80842f30$var$controlServings = (serving)=>{
    $0f43de04ce3b058c$export$5e23f4642ecad5ea(serving);
    (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).update($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe);
};
const $292b382f80842f30$var$controlBookmark = ()=>{
    if (!$0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.bookmarked) $0f43de04ce3b058c$export$72009cc673d27d80($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe);
    else $0f43de04ce3b058c$export$2db69b245b3902c8($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.id);
    (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).update($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe);
    (0, $bb8c26dfe22e3ec0$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks);
};
const $292b382f80842f30$var$controlLoadBookmarks = ()=>{
    $0f43de04ce3b058c$export$7c7816efe5f3d2b8();
    (0, $bb8c26dfe22e3ec0$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks);
};
const $292b382f80842f30$var$controlAddRecipe = async (recipe)=>{
    try {
        (0, $69f230dbd0cf4929$export$2e2bcd8739ae039).renderSpinner();
        await $0f43de04ce3b058c$export$d660c2254e74960d(recipe);
        (0, $bb8c26dfe22e3ec0$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks);
        (0, $69f230dbd0cf4929$export$2e2bcd8739ae039).renderMessage();
        window.location.hash = $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.id;
    } catch (err) {
        (0, $69f230dbd0cf4929$export$2e2bcd8739ae039).renderError(err);
    }
};
const $292b382f80842f30$var$controlSearch = (parent, button)=>{
    if (!$0f43de04ce3b058c$export$ca000e230c0caa3e.isSearchOpen) {
        let actionEvent;
        $0f43de04ce3b058c$export$ca000e230c0caa3e.isSearchOpen = true;
        document.removeEventListener("click", actionEvent);
        parent.classList.add("search-open");
        console.log($0f43de04ce3b058c$export$ca000e230c0caa3e.isSearchOpen);
        actionEvent = (e)=>{
            if (!e.target.closest(".search") && !e.target.closest(".nav .search__btn")) {
                $0f43de04ce3b058c$export$ca000e230c0caa3e.isSearchOpen = false;
                console.log($0f43de04ce3b058c$export$ca000e230c0caa3e.isSearchOpen);
                parent.classList.remove("search-open");
                document.removeEventListener("click", actionEvent);
            }
        };
        document.addEventListener("click", actionEvent);
    }
};
const $292b382f80842f30$var$init = ()=>{
    (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).addHandlerRender($292b382f80842f30$var$getRecipe);
    (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).addHandlerUpdateServings($292b382f80842f30$var$controlServings);
    (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).addHandlerBookmark($292b382f80842f30$var$controlBookmark);
    (0, $bb8c26dfe22e3ec0$export$2e2bcd8739ae039).addHandlerRender($292b382f80842f30$var$controlLoadBookmarks);
    (0, $59c24ae67929f662$export$2e2bcd8739ae039).addSearchHandler($292b382f80842f30$var$controlSearchResults);
    (0, $59c24ae67929f662$export$2e2bcd8739ae039).addSearchButtonHandler($292b382f80842f30$var$controlSearch);
    (0, $d5cb92833965f6d1$export$2e2bcd8739ae039).addPaginationHandler($292b382f80842f30$var$controlPagination);
    (0, $69f230dbd0cf4929$export$2e2bcd8739ae039).addHandlerSubmit($292b382f80842f30$var$controlAddRecipe);
    console.log("Welcome to Forkify!");
};
$292b382f80842f30$var$init();


//# sourceMappingURL=index.681c27e2.js.map
